import { Icon24SoundOn } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

export const SPEAKER_HIGH_ICON_PATHS = [
  'M7.5 15.8611H3C2.80109 15.8611 2.61032 15.7821 2.46967 15.6414C2.32902 15.5008 2.25 15.31 2.25 15.1111V9.11108C2.25 8.91217 2.32902 8.72141 2.46967 8.58075C2.61032 8.4401 2.80109 8.36108 3 8.36108H7.5L14.25 3.11108V21.1111L7.5 15.8611Z',
  'M7.5 8.36108V15.8611',
  'M18 10.1282C18.4825 10.676 18.7487 11.381 18.7487 12.111C18.7487 12.841 18.4825 13.546 18 14.0938',
  'M20.7815 7.61108C21.8884 8.84863 22.5003 10.4507 22.5003 12.1111C22.5003 13.7714 21.8884 15.3735 20.7815 16.6111',
];

const SpeakerHighIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_532_333)">
        {SPEAKER_HIGH_ICON_PATHS.map((d) => (
          <path key={d} d={d} stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
        ))}
      </g>
      <defs>
        <clipPath id="clip0_532_333">
          <rect width="24" height="24" fill="currentColor" transform="translate(0 0.111084)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SpeakerHighIcon = fplIcon(SpeakerHighIconLocal, Icon24SoundOn);
